import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";

export const compareGeoFencingRules = (g1, g2) => g1.id === g2.id;

const geoFencingSlice = createSlice({
    name: 'geofencing',
    initialState: {
        rules: []
    },
    reducers: {
        set: (state, action) => {
            state.rules = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const rule of ensureArray(action.payload)) {
                const idx = state.rules.findIndex(r => compareGeoFencingRules(r, rule));
                if (idx > -1) {
                    state.rules.splice(idx, 1, rule);
                } else {
                    state.rules.push(rule);
                }
            }
        },
        remove: (state, action) => {
            for (const rule of ensureArray(action.payload)) {
                const idx = state.rules.findIndex(r => compareGeoFencingRules(r, rule));
                if (idx > -1) {
                    state.rules.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => geoFencingSlice.getInitialState());
    }
});

// #region network operations
const fetchAllGeoFenceRules = network => network.get('/api/v1/geofencingRules', geoFencingSlice.actions.set);
export const insertGeoFenceRule = (network, rule) => network.post('/api/v1/geofencingRule', rule, geoFencingSlice.actions.addOrUpdate);
export const updateGeoFenceRule = (network, rule) => network.put('/api/v1/geofencingRule', rule, geoFencingSlice.actions.addOrUpdate);
export const removeGeoFenceRule = (network, rule) => network.delete('/api/v1/geofencingRule/' + encodeURIComponent(rule.id), geoFencingSlice.actions.remove);
// #endregion

// #region selectors
const selectAllRules = state => state.geofencing.rules;
// #endregion

// #region listeners
const listen = {
    geofenceCreated: (rule, { dispatch }) => dispatch(geoFencingSlice.actions.addOrUpdate(rule)),
    geofenceUpdated: (rule, { dispatch }) => dispatch(geoFencingSlice.actions.addOrUpdate(rule)),
    geofenceRemoved: (rule, { dispatch }) => dispatch(geoFencingSlice.actions.remove(rule))
}
// #endregion

// #region permission checks
export const canCreateGeoFencingRule = (credentials, rule) => credentials.access.hasFull('administrator');
export const canUpdateGeoFencingRule = (credentials, rule) => credentials.access.hasFull('administrator');
export const canRemoveGeoFencingRule = (credentials, rule) => credentials.access.hasFull('administrator');
// #endregion

export const [useGeoFencingRules] = dataHookFactory(selectAllRules, { run: fetchAllGeoFenceRules, listen });

const reducerDetails = { name: geoFencingSlice.name, reducer: geoFencingSlice.reducer };
export default reducerDetails;